import { NavLink, useLocation } from "react-router-dom";
import useCustomerAuth from "../../legacy/hooks/useCustomerAuth";
import "../styles/mobile-footer-redesign.css";

const items = [
  { to: "/", label: "Home", icon: "bi-house" },
  { to: "/stays", label: "Explore", icon: "bi-search" },
  { to: "/packages", label: "Packages", icon: "bi-suitcase-lg" },
  { to: "/cabs", label: "Cabs", icon: "bi-car-front" },
  { to: "/account", label: "Profile", guestLabel: "Login", icon: "bi-person" },
];

export default function MobileBottomNav() {
  const { customer, accessToken } = useCustomerAuth();
  const location = useLocation();
  const loggedIn = Boolean(customer && accessToken);
  const path = location.pathname;
  const isExplorePath =
    path === "/search" ||
    path.startsWith("/stays") ||
    path.startsWith("/listings") ||
    path.startsWith("/property");

  const isActiveItem = (item, navLinkActive) => {
    if (item.to === "/stays") return isExplorePath;
    return navLinkActive;
  };

  return (
    <nav className="hv-mobile-bottom-nav" aria-label="Mobile navigation">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === "/"}
          className={({ isActive }) =>
            `hv-mobile-bottom-nav__item${isActiveItem(item, isActive) ? " is-active" : ""}`
          }
        >
          <span className="hv-mobile-bottom-nav__icon">
            <i className={`bi ${item.icon}`} aria-hidden="true" />
          </span>
          <span className="hv-mobile-bottom-nav__label">{!loggedIn && item.guestLabel ? item.guestLabel : item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
